import React, { useState } from "react";

import axios from "axios";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";
import LoadingSpinner from "../../../components/LoadingSpinner";

export default function ReportClubModal({ club, cancelModal }) {
  const { user } = useAuthContext();
  const [complete, setComplete] = useState(false);
  const [reason, setReason] = useState("");
  const [reasonErr, setReasonErr] = useState("");
  const [notes, setNotes] = useState("");
  const [notesErr, setNotesErr] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  //styled

  const handleReportPost = async (e) => {
    e.preventDefault();
    setIsLoading(true); // Start loading state
    let err = false;

    if (reason === "empty" || reason.length === 0) {
      err = true;
      setReasonErr("Must select a reason");
    }

    if (notes.length === 0) {
      err = true;
      setNotesErr("Must fill in");
    }

    if (!err) {
      const createReportClub = {
        reason,
        notes,
      };

      try {
        const pinResponse = await axios.post(
          `${ApiConnectionString}/api/ReportClub/${club.id}`,
          createReportClub,
          {
            headers: { Authorization: `Bearer ${user.token}` },
          }
        );

        if (pinResponse.status === 200) {
          setComplete(true); // Mark as complete
        }
      } catch (error) {
        console.error("Failed to report the club:", error); // Log error for debugging
      } finally {
        setIsLoading(false); // Stop loading state
      }
    } else {
      setIsLoading(false); // Stop loading state if there's validation error
    }
  };

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
        </div>
      </div>
    );
  } else {
    if (complete) {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">Club Reported</p>
            </div>

            <button
              type="button"
              className="close-button"
              onClick={cancelModal}
              aria-label="Close"
            >
              &times;
            </button>
            <p>The club report has been filed. Thank you.</p>

            <div className="send-modal-footer">
              <button
                onClick={cancelModal}
                className="pointer cancelButton fw-bold mx-2 px-3"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">Report This Club</p>
            </div>

            <button
              type="button"
              className="close-button"
              onClick={cancelModal}
              aria-label="Close"
            >
              &times;
            </button>

            <div>
              <p className="red-text fw-bold"> {club.name}</p>
            </div>

            <div>
              <div>
                <label htmlFor="reason">Reason for reporting:</label>
                <select
                  id="reason"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                >
                  <option value="empty">Select a reason</option>
                  <option value="spam">Spam</option>
                  <option value="abuse">Abuse</option>
                  <option value="harassment">Harassment</option>
                  <option value="other">Other</option>
                </select>
                {reasonErr && <p className="text-danger">{reasonErr}</p>}
              </div>
              <div>
                <label htmlFor="notes">Additional notes:</label>
                <textarea
                  id="notes"
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                />
              </div>
              {notesErr && <p className="text-danger">{notesErr}</p>}
            </div>

            <div className="send-modal-footer">
              <button className="delete-button mx-3" onClick={handleReportPost}>
                Submit Report
              </button>
              <button
                onClick={cancelModal}
                className="pointer cancelButton fw-bold mx-2 px-3"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      );
    }
  }
}
